import type { ArticlePreview, FetchArticlePreviewPayload } from '@src/scenario-editor/providers/fetch.context';

// Hover previews in the Suggestions picker: each article is fetched once per
// page load, and a second hover over the same row renders from here without a
// request. A failed fetch is not cached, so the next hover retries it.
const previews = new Map<string, ArticlePreview>();
const inflight = new Map<string, Promise<ArticlePreview>>();

export const getCachedArticlePreview = (id: string) => previews.get(id);

export const loadArticlePreview = (
  id: string,
  fetchArticlePreview: (id: string) => Promise<FetchArticlePreviewPayload>
): Promise<ArticlePreview> => {
  const cached = previews.get(id);
  if (cached) return Promise.resolve(cached);

  const pending = inflight.get(id);
  if (pending) return pending;

  const request = fetchArticlePreview(id)
    .then(({ data }) => {
      previews.set(id, data);
      return data;
    })
    .finally(() => {
      inflight.delete(id);
    });
  inflight.set(id, request);
  return request;
};

export const clearArticlePreviewCache = () => {
  previews.clear();
  inflight.clear();
};
